import { useCallback } from 'react';

import { usePaymentContext } from 'features/payment';
import { CardTypes, IPaymentPayload } from 'features/payment/types';

import { getNonce } from 'remote/api/first-data';
import { getConfigValue } from 'utils/environment';
import { ISOs } from 'utils/form/constants';

import { ICashApp, ICashAppResult } from '../types';

export const useCashAppOnCompleteHelper = ({ onResult }: Pick<ICashApp, 'onResult'>) => {
  const { getEncryptionDetails } = usePaymentContext();
  const firstData = getConfigValue({ key: 'firstData', defaultValue: {} });

  const onComplete = useCallback(
    async (event: { data: ICashAppResult }) => {
      const encryptionDetails = await getEncryptionDetails();

      const payload: IPaymentPayload = {
        billingAddress: {
          unitNumber: null,
          locality: null,
          postalCode: '',
          region: null,
          streetAddress: null,
          country: ISOs.US,
        },
        cardNumber: event.data.virtualCard.cardNumber,
        cardType: CardTypes.VISA,
        expiryDate: {
          month: event.data.virtualCard.expiryMonth,
          year: event.data.virtualCard.expiryYear,
        },
        nameOnCard: '',
        securityCode: event.data.virtualCard.cvc,
      };

      const nonceResponse = await getNonce(
        payload,
        encryptionDetails.fdPublicKey,
        encryptionDetails.fdApiKey,
        encryptionDetails.fdAccessToken,
        encryptionDetails.fdCustomerId || null,
        firstData.baseUrl,
        true,
        encryptionDetails.algorithm || undefined
      );
      const nonce = await nonceResponse.json();

      onResult({
        ...event.data,
        fdAccessToken: encryptionDetails.fdAccessToken,
        fdNonce: nonce.token.tokenId,
      });
    },
    [getEncryptionDetails, onResult, firstData.baseUrl]
  );

  return { onComplete };
};
